import React, { Component } from 'react';
import { AppContext } from '../context/AppContext';
import {
  getMyBusinessProductsGrouped,
  updateBusinessProduct,
} from '../services/myProductsService';

class MyProductsPage extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      savingProductId: '',
      errorMessage: '',
      successMessage: '',

      rawCatalog: null,
      flattenedProducts: [],

      viewMode: 'table',
      searchTerm: '',
      currentPage: 1,
      itemsPerPage: 20,

      selectedCategoryCode: '',
      selectedSubcategoryCode: '',

      expandedForms: {},
      formDataByProductId: {},
      __selectedBusinessId: '',
    };
  }

  componentDidMount() {
    this.loadProducts();
  }

  componentDidUpdate() {
    const { state } = this.context;

    if (
      state.selectedBusinessId &&
      this.state.__selectedBusinessId !== state.selectedBusinessId
    ) {
      this.setState(
        {
          __selectedBusinessId: state.selectedBusinessId,
        },
        () => {
          this.loadProducts();
        }
      );
    }
  }

  loadProducts = () => {
    const { state } = this.context;
    const businessId = state.selectedBusinessId;

    if (!businessId) {
      this.setState({
        loading: false,
        errorMessage: 'לא נבחר עסק',
      });
      return;
    }

    this.setState({
      loading: true,
      errorMessage: '',
      successMessage: '',
    });

    getMyBusinessProductsGrouped(businessId)
      .then((data) => {
        const flattenedProducts = this.flattenCatalog(data);
        const formDataByProductId = this.buildInitialForms(flattenedProducts);

        const categoryCodes = Object.keys((data && data.categories) || {});
        const firstCategoryCode = categoryCodes.length > 0 ? categoryCodes[0] : '';
        const firstSubcategoryCode =
          firstCategoryCode &&
          data.categories[firstCategoryCode] &&
          data.categories[firstCategoryCode].subcategories
            ? Object.keys(data.categories[firstCategoryCode].subcategories)[0] || ''
            : '';

        this.setState({
          loading: false,
          rawCatalog: data,
          flattenedProducts: flattenedProducts,
          formDataByProductId: formDataByProductId,
          currentPage: 1,
          selectedCategoryCode: firstCategoryCode,
          selectedSubcategoryCode: firstSubcategoryCode,
          __selectedBusinessId: businessId,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'שגיאה בטעינת המוצרים',
        });
      });
  };

  flattenCatalog = (catalogData) => {
    const result = [];
    const categories = (catalogData && catalogData.categories) || {};

    Object.keys(categories).forEach((categoryCode) => {
      const category = categories[categoryCode];
      const subcategories = category.subcategories || {};

      Object.keys(subcategories).forEach((subcategoryCode) => {
        const subcategory = subcategories[subcategoryCode];
        const products = subcategory.products || [];

        products.forEach((product) => {
          result.push({
            ...product,
            category_code_from_tree: categoryCode,
            category_name_from_tree: category.name,
            subcategory_code_from_tree: subcategoryCode,
            subcategory_name_from_tree: subcategory.name,
          });
        });
      });
    });

    return result;
  };

  buildInitialForms = (products) => {
    const forms = {};

    products.forEach((product) => {
      forms[product.business_product_id] = {
        price: product.price || '',
        original_price: product.original_price || '',
        sale_price: product.sale_price || '',
        stock_quantity:
          product.stock_quantity !== null && product.stock_quantity !== undefined
            ? product.stock_quantity
            : 99,
        stock_status: product.stock_status || 'in_stock',
        is_visible:
          product.is_visible !== null && product.is_visible !== undefined
            ? product.is_visible
            : true,
        is_featured:
          product.is_featured !== null && product.is_featured !== undefined
            ? product.is_featured
            : true,
        custom_title: product.custom_title || '',
        custom_image: null,
      };
    });

    return forms;
  };

  handleSearchChange = (event) => {
    this.setState({
      searchTerm: event.target.value,
      currentPage: 1,
    });
  };

  handleViewModeChange = (mode) => {
    this.setState({
      viewMode: mode,
    });
  };

  handlePageChange = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  handleCategorySelect = (categoryCode) => {
    const { rawCatalog } = this.state;
    const category = rawCatalog.categories[categoryCode];
    const subcategoryCodes = Object.keys((category && category.subcategories) || {});
    const firstSubcategoryCode = subcategoryCodes.length > 0 ? subcategoryCodes[0] : '';

    this.setState({
      selectedCategoryCode: categoryCode,
      selectedSubcategoryCode: firstSubcategoryCode,
    });
  };

  handleSubcategorySelect = (subcategoryCode) => {
    this.setState({
      selectedSubcategoryCode: subcategoryCode,
    });
  };

  handleToggleEdit = (businessProductId) => {
    this.setState((prevState) => ({
      expandedForms: {
        ...prevState.expandedForms,
        [businessProductId]: !prevState.expandedForms[businessProductId],
      },
    }));
  };

  handleProductFieldChange = (businessProductId, fieldName, value) => {
    this.setState((prevState) => {
      const existingForm = prevState.formDataByProductId[businessProductId] || {};

      return {
        formDataByProductId: {
          ...prevState.formDataByProductId,
          [businessProductId]: {
            ...existingForm,
            [fieldName]: value,
          },
        },
      };
    });
  };

  handleProductSwitchChange = (businessProductId, fieldName, checked) => {
    this.handleProductFieldChange(businessProductId, fieldName, checked);
  };

  handleProductImageChange = (businessProductId, event) => {
    const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
    this.handleProductFieldChange(businessProductId, 'custom_image', file);
  };

  handleSaveProduct = (product) => {
    const { state } = this.context;
    const businessId = state.selectedBusinessId;
    const form =
      this.state.formDataByProductId[product.business_product_id] || {};

    const payload = {
      business_product_id: product.business_product_id,
      business_id: businessId,
      product_id: product.product_id,
      price: form.price,
      original_price: form.original_price,
      sale_price: form.sale_price,
      stock_quantity: form.stock_quantity,
      stock_status: form.stock_status,
      is_visible: form.is_visible,
      is_featured: form.is_featured,
      custom_title: form.custom_title,
      custom_image: form.custom_image,
    };

    this.setState({
      savingProductId: product.business_product_id,
      errorMessage: '',
      successMessage: '',
    });

    updateBusinessProduct(payload)
      .then((response) => {
        this.setState({
          savingProductId: '',
          successMessage: response.message || 'המוצר עודכן בהצלחה',
          expandedForms: {
            ...this.state.expandedForms,
            [product.business_product_id]: false,
          },
        });

        this.loadProducts();
      })
      .catch((error) => {
        this.setState({
          savingProductId: '',
          errorMessage: error.message || 'שגיאה בעדכון המוצר',
        });
      });
  };

  getFilteredProducts = () => {
    const { flattenedProducts, searchTerm } = this.state;

    if (!searchTerm.trim()) {
      return flattenedProducts;
    }

    const lowered = searchTerm.toLowerCase();

    return flattenedProducts.filter((product) => {
      return (
        (product.name && product.name.toLowerCase().includes(lowered)) ||
        (product.brand_name && product.brand_name.toLowerCase().includes(lowered)) ||
        (product.barcode && product.barcode.toLowerCase().includes(lowered)) ||
        (product.category_name && product.category_name.toLowerCase().includes(lowered)) ||
        (product.subcategory_name && product.subcategory_name.toLowerCase().includes(lowered)) ||
        (product.custom_title && product.custom_title.toLowerCase().includes(lowered))
      );
    });
  };

  getPaginatedProducts = () => {
    const { currentPage, itemsPerPage } = this.state;
    const filtered = this.getFilteredProducts();

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    return filtered.slice(startIndex, endIndex);
  };

  getTotalPages = () => {
    const { itemsPerPage } = this.state;
    const filtered = this.getFilteredProducts();

    return Math.max(1, Math.ceil(filtered.length / itemsPerPage));
  };

  renderPagination = () => {
    const totalPages = this.getTotalPages();
    const { currentPage } = this.state;

    if (totalPages <= 1) {
      return null;
    }

    const pageButtons = [];

    for (let i = 1; i <= totalPages; i += 1) {
      pageButtons.push(
        <button
          key={i}
          className={currentPage === i ? 'pagination-btn active' : 'pagination-btn'}
          onClick={() => this.handlePageChange(i)}
          type="button"
        >
          {i}
        </button>
      );
    }

    return <div className="pagination-wrapper">{pageButtons}</div>;
  };

  renderInlineProductForm = (product) => {
    const form =
      this.state.formDataByProductId[product.business_product_id] || {};
    const isSaving =
      this.state.savingProductId === product.business_product_id;

    return (
      <div className="product-form-box">
        <div className="product-form-grid">
          <div className="form-group">
            <label>מחיר</label>
            <input
              type="number"
              value={form.price}
              onChange={(e) =>
                this.handleProductFieldChange(
                  product.business_product_id,
                  'price',
                  e.target.value
                )
              }
              placeholder="מחיר"
            />
          </div>

          <div className="form-group">
            <label>מחיר מקורי</label>
            <input
              type="number"
              value={form.original_price}
              onChange={(e) =>
                this.handleProductFieldChange(
                  product.business_product_id,
                  'original_price',
                  e.target.value
                )
              }
              placeholder="מחיר מקורי"
            />
          </div>

          <div className="form-group">
            <label>מחיר מבצע</label>
            <input
              type="number"
              value={form.sale_price}
              onChange={(e) =>
                this.handleProductFieldChange(
                  product.business_product_id,
                  'sale_price',
                  e.target.value
                )
              }
              placeholder="מחיר מבצע"
            />
          </div>

          <div className="form-group">
            <label>יחידות במלאי</label>
            <input
              type="number"
              value={form.stock_quantity}
              onChange={(e) =>
                this.handleProductFieldChange(
                  product.business_product_id,
                  'stock_quantity',
                  e.target.value
                )
              }
              placeholder="99"
            />
          </div>

          <div className="form-group">
            <label>מצב מלאי</label>
            <select
              value={form.stock_status}
              onChange={(e) =>
                this.handleProductFieldChange(
                  product.business_product_id,
                  'stock_status',
                  e.target.value
                )
              }
            >
              <option value="in_stock">במלאי</option>
              <option value="out_of_stock">לא במלאי</option>
              <option value="limited">מוגבל</option>
            </select>
          </div>

          <div className="form-group">
            <label>כותרת מותאמת אישית</label>
            <input
              type="text"
              value={form.custom_title}
              onChange={(e) =>
                this.handleProductFieldChange(
                  product.business_product_id,
                  'custom_title',
                  e.target.value
                )
              }
              placeholder="לא חובה"
            />
          </div>

          <div className="form-group full-width">
            <label>תמונה מותאמת אישית</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                this.handleProductImageChange(product.business_product_id, e)
              }
            />
            {product.custom_image_url ? (
              <div className="current-image-note">
                יש תמונה מותאמת קיימת
              </div>
            ) : (
              <div className="current-image-note">
                אין תמונה מותאמת. אפשר להשאיר ריק
              </div>
            )}
          </div>

          <div className="form-group switch-group">
            <label>גלוי</label>
            <input
              type="checkbox"
              checked={!!form.is_visible}
              onChange={(e) =>
                this.handleProductSwitchChange(
                  product.business_product_id,
                  'is_visible',
                  e.target.checked
                )
              }
            />
          </div>

          <div className="form-group switch-group">
            <label>מומלץ</label>
            <input
              type="checkbox"
              checked={!!form.is_featured}
              onChange={(e) =>
                this.handleProductSwitchChange(
                  product.business_product_id,
                  'is_featured',
                  e.target.checked
                )
              }
            />
          </div>
        </div>

        <div className="save-action-row">
          <button
            type="button"
            className="save-product-btn"
            onClick={() => this.handleSaveProduct(product)}
            disabled={isSaving}
          >
            {isSaving ? 'שומר...' : 'שמור'}
          </button>
        </div>
      </div>
    );
  };

  renderTableView = () => {
    const paginatedProducts = this.getPaginatedProducts();
    const { expandedForms } = this.state;

    return (
      <div className="products-table-wrapper">
        <table className="products-table">
          <thead>
            <tr>
              <th>עדכון</th>
              <th>תמונה</th>
              <th>שם מוצר</th>
              <th>כותרת מותאמת</th>
              <th>מותג</th>
              <th>קטגוריה</th>
              <th>תת קטגוריה</th>
              <th>מחיר</th>
              <th>מלאי</th>
            </tr>
          </thead>
          <tbody>
            {paginatedProducts.map((product) => {
              const expanded = expandedForms[product.business_product_id] || false;

              return (
                <React.Fragment key={product.business_product_id}>
                  <tr>
                    <td>
                      <button
                        type="button"
                        className="edit-icon-btn"
                        onClick={() =>
                          this.handleToggleEdit(product.business_product_id)
                        }
                        title="ערוך מוצר"
                      >
                        ✏️
                      </button>
                    </td>
                    <td>
                      <img
                        src={`http://127.0.0.1:8000/${product.custom_image_url || `mediafiles/${product.image_url}`}`}
                        alt={product.name}
                        className="table-product-image"
                      />
                    </td>
                    <td>{product.name}</td>
                    <td>{product.custom_title || '-'}</td>
                    <td>{product.brand_name || '-'}</td>
                    <td>{product.category_name || product.category_name_from_tree}</td>
                    <td>
                      {product.subcategory_name ||
                        product.subcategory_name_from_tree}
                    </td>
                    <td>{product.price || '-'}</td>
                    <td>{product.stock_quantity || '-'}</td>
                  </tr>

                  {expanded && (
                    <tr className="expanded-row">
                      <td colSpan="9">{this.renderInlineProductForm(product)}</td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>

        {this.renderPagination()}
      </div>
    );
  };

  renderBrowserProducts = () => {
    const {
      rawCatalog,
      selectedCategoryCode,
      selectedSubcategoryCode,
      expandedForms,
    } = this.state;

    if (!rawCatalog || !rawCatalog.categories || !selectedCategoryCode) {
      return <div className="empty-state">אין נתונים להצגה</div>;
    }

    const category = rawCatalog.categories[selectedCategoryCode];
    const subcategories = (category && category.subcategories) || {};
    const selectedSubcategory = subcategories[selectedSubcategoryCode];
    const products = (selectedSubcategory && selectedSubcategory.products) || [];

    return (
      <div className="browser-layout">
        <div className="browser-column browser-column-right">
          <div className="browser-column-title">קטגוריות</div>
          {Object.keys(rawCatalog.categories).map((categoryCode) => (
            <button
              key={categoryCode}
              className={
                selectedCategoryCode === categoryCode
                  ? 'browser-item active'
                  : 'browser-item'
              }
              type="button"
              onClick={() => this.handleCategorySelect(categoryCode)}
            >
              {rawCatalog.categories[categoryCode].name}
            </button>
          ))}
        </div>

        <div className="browser-column browser-column-middle">
          <div className="browser-column-title">תתי קטגוריות</div>
          {Object.keys(subcategories).map((subcategoryCode) => (
            <button
              key={subcategoryCode}
              className={
                selectedSubcategoryCode === subcategoryCode
                  ? 'browser-item active'
                  : 'browser-item'
              }
              type="button"
              onClick={() => this.handleSubcategorySelect(subcategoryCode)}
            >
              {subcategories[subcategoryCode].name}
            </button>
          ))}
        </div>

        <div className="browser-column browser-column-left">
          <div className="browser-column-title">מוצרים</div>

          {products.map((product) => {
            const expanded = expandedForms[product.business_product_id] || false;

            return (
              <div className="browser-product-card" key={product.business_product_id}>
                <div className="browser-product-header">
                  <div className="browser-product-main">
                    <img
                      src={`http://127.0.0.1:8000/${product.custom_image_url || `mediafiles/${product.image_url}`}`}
                      alt={product.name}
                      className="browser-product-image"
                    />

                    <div className="browser-product-info">
                      <div className="browser-product-name">{product.name}</div>
                      <div className="browser-product-meta">
                        {product.custom_title || product.brand_name || '-'}
                      </div>
                      <div className="browser-product-meta">
                        מחיר: {product.price || '-'}
                      </div>
                      <div className="browser-product-meta">
                        מלאי: {product.stock_quantity || '-'}
                      </div>
                    </div>
                  </div>

                  <div className="browser-product-checkbox">
                    <button
                      type="button"
                      className="edit-icon-btn"
                      onClick={() =>
                        this.handleToggleEdit(product.business_product_id)
                      }
                      title="ערוך מוצר"
                    >
                      ✏️
                    </button>
                  </div>
                </div>

                {expanded && this.renderInlineProductForm(product)}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { state } = this.context;
    const {
      loading,
      errorMessage,
      successMessage,
      viewMode,
      searchTerm,
      rawCatalog,
    } = this.state;

    if (loading) {
      return (
        <div className="simple-page">
          <div className="simple-page-card">
            <h2>המוצרים שלי</h2>
            <p>טוען נתונים...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="simple-page">
        <div className="products-page-card">
          <div className="products-page-header">
            <div>
              <h2>המוצרים שלי</h2>
              <p className="page-subtitle">
                עסק נבחר:{' '}
                {rawCatalog && rawCatalog.business_name
                  ? rawCatalog.business_name
                  : state.selectedBusinessId}
              </p>
            </div>

            <div className="view-mode-switch">
              <button
                type="button"
                className={viewMode === 'table' ? 'mode-btn active' : 'mode-btn'}
                onClick={() => this.handleViewModeChange('table')}
              >
                טבלה
              </button>

              <button
                type="button"
                className={viewMode === 'browser' ? 'mode-btn active' : 'mode-btn'}
                onClick={() => this.handleViewModeChange('browser')}
              >
                קטגוריות
              </button>
            </div>
          </div>

          {errorMessage && <div className="message-box error-box">{errorMessage}</div>}
          {successMessage && <div className="message-box success-box">{successMessage}</div>}

          <div className="products-top-toolbar">
            <input
              type="text"
              className="products-search-input"
              placeholder="חיפוש לפי שם מוצר, כותרת מותאמת, מותג, ברקוד, קטגוריה..."
              value={searchTerm}
              onChange={this.handleSearchChange}
            />
          </div>

          {viewMode === 'table' ? this.renderTableView() : this.renderBrowserProducts()}
        </div>
      </div>
    );
  }
}

export default MyProductsPage;